import RemoteCall from "../../util/RemoteCall";

const remoteCall = new RemoteCall("api/nursecarecore/hospital");

// 获取当前医院的启用信息
const findInstallStatusAsync = (params) => {
    return remoteCall.invoke("findInstallStatus", params);
};

const findAppModulesAsync = (params) => {
    return remoteCall.invoke("findAppModules", params);
};

const getHospitalAsync = (params) => {
    return remoteCall.invoke("getHospital", params);
};

const _getHospitalAsync = (params) => {
    return remoteCall._invoke("getHospital", params);
};

const updateLogoNameAsync = (params) => {
    return remoteCall.invoke("updateLogoName", params);
};

const updateAppModuleStatusAsync = (params) => {
    return remoteCall.invoke("updateAppModuleStatus", params);
};

const addAppModuleAsync = (params) => {
    return remoteCall.invoke("addAppModule", params);
};

const updateAppModuleAsync = (params) => {
    return remoteCall.invoke("updateAppModule", params);
};

const updateMobileBannerAsync = (params) => {
    return remoteCall.invoke("updateMobileBanner", params);
};

const createHospitalAsync = (params) => {
    return remoteCall.invoke("createHospital", params);
};

const updateHospitalAsync = (param) => {
    return remoteCall.invoke("updateHospital", param);
};

const deleteHospitalAsync = (param) => {
    return remoteCall.invoke("deleteHospital", param);
};

const findAllAsync = (param) => {
    return remoteCall.invoke("findAll", param);
};

const deleteAppModuleAsync = (param) => {
    return remoteCall.invoke("deleteAppModule", param);
};

export default {
    findInstallStatusAsync,
    findAppModulesAsync,
    getHospitalAsync,
    _getHospitalAsync,
    updateLogoNameAsync,
    updateAppModuleStatusAsync,
    addAppModuleAsync,
    updateAppModuleAsync,
    updateMobileBannerAsync,
    createHospitalAsync,
    updateHospitalAsync,
    deleteHospitalAsync,
    findAllAsync,
    deleteAppModuleAsync,
};
